import { Component, useEffect, useContext, useState, createRef } from "react";
import ReactDOM from 'react-dom';

import Divider from "../../../components/divider/divider";
import Container from "../../../layouts/containers/container";
import SixtyFourtyLayout from '../../../layouts/layout-sixty-fourty';
import LabelContainer from "../../../components/label-container";
import Grid from "../../../components/grid";
import Blurred from "../../../components/blurred";
import ContainerGrid from "../../../layouts/containers/container-grid";
import List from "../../../components/list";
import Welcome from "../../../layouts/welcome";
import NavItem from "../nav-link";
import Row from "../../../components/row";
import { Layout } from "../../../layouts";
import DateTimeInput from "../../../components/inputs/date-time-input";
import InputsCounter from "../../../components/inputs/inputs-counter";
import MediaHelper from '../../../lib/helpers/media';
import InputsCheckbox from "../../../components/inputs/inputs-checkbox";
import { FormatMonths } from "../../../lib/helpers";
import { MinMaxLayout } from '../../../layouts/index';
import PopupContext from "../../../context/context-popup";
import { ButtonModify } from "../../../components/buttons";
import ContainerTable from '../../../layouts/containers/container-table';
import membershipsApi from "../../../lib/memberships/memberships-api";
import companiesApi from "../../../lib/companies/companies-api";
import Darkener from "../../../components/darkener";

import seamApi from "../../../lib/seam-api";

import _ from 'lodash';

const el = document.getElementById('membership');

const YourDetails = ({ booker }) => {
    const Item = ({ title, value }) => {
        return (
            <List gap='10px' style={{ flex: '1 0 0' }}>
                <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">{ title }</Container.Title>
                <Container.Text fontSize="16px">{ value }</Container.Text>
            </List>
        )
    }

    const Flex = ({ direction, children }) => {
        return (
            <div style={{
                display: 'flex',
                flexDirection: direction,
                gap: '20px',
            }}>
                { children }
            </div>
        )
    }

    const profile = booker?.billing_profile;

    return (
        <Container>
            <Container.Header>
                <Container.Text color="#FF6933" fontSize="18px">Your Billing Details</Container.Text>
            </Container.Header>

            <Container.Content>
                <Flex direction="column">
                    <Flex direction="row">
                        <Item title="First Name" value={profile?.first_name}/>
                        <Item title="Last Name" value={profile?.last_name}/>
                    </Flex>
                    <Flex direction="row">
                        <Item title="Company" value={profile?.company_name}/>
                    </Flex>
                    <Item title="Email Address" value={profile?.email_address}/>
                    <Flex direction="row">
                        <Item title="Telephone Number" value={profile?.tel_no}/>
                        <Item title="SAP Number" value={profile?.sap_number}/>
                    </Flex>
                </Flex>
            </Container.Content>
        </Container>
    )
}

const Summary = ({
    membership
}) => {
    const data = []

    data.unshift([
        1,
        membership?.name,
        `£${membership?.monthly_price}`
    ])

    return (
        <ContainerTable
            showMobileColumns
            headerColor="rgb(146, 155, 168)"
            valueColor="black"
            className="table-bookings"
            columns={[
                { field: 'QTY', width: '25%' },
                { field: 'Item', width: '50%' },
                { field: 'Price', width: '25%' },
            ]}
            data={[
                ...data
            ]}
        />
    )
}

class Membership extends Component {
    constructor(props) {
        super(props);

        this.state = {
           params: {},
           membership: null,
           agree: false,
           topBarRef: null,
           imageRef: null,
           oldImageRef: null,
       }
   }

   componentDidMount() {
       this.getMembership();
       this.onResize()
   }

   onImageRef(ref) {
       if (this.state.imageRef === null) {
           this.setState({ imageRef: ref }, () => {
               this.resizeImage();
           })
       }
   }

   onTopBarRef(ref) {
       if (this.state.topBarRef === null) {
           this.setState({ topBarRef: ref }, () => {
               this.resizeImage();
           })
       }
   }

   onResize() {    
       this.resizeImage();

       window.addEventListener('resize', this.resizeImage.bind(this))
   }

   resizeImage() {
       const overflow = 100;

       if (this.state.imageRef !== null) {
           this.state.imageRef.style.height = `calc(300.96px + ${this.state.topBarRef?.offsetHeight}px + ${overflow}px)`;
       }
   }

    getMembership() {
        seamApi.memberships().getMembership(this.props.id).then(({ data }) => {
            this.setState({ membership: data });
        });
    }

    handleProceed() {
        let form = document.createElement('form');

        form.action = '/memberships/' + this.props.id;
        form.method = 'post';

        let input = document.createElement('input');

        form.appendChild(input);
        document.body.appendChild(form);

        form.submit();
    }

    getFeaturedImage() {
        const image = this.state.membership?.content?.feature_image?.[0];

        if (image?.file_name === undefined) return '/images/office.png';

        return MediaHelper.formatPublicPath(`/images/${image?.file_name}`);
    }

    setErrors(errors) {
        this.setstate({ errors });

        toast.error(Object.values(errors)?.join(' - '), {
            position: toast.POSITION.TOP_RIGHT
        });
    }

    render() {
        const featuredImage = this.getFeaturedImage();

        if (this.state.membership === null) return null;

        return <div className="meeting-booking membership">
            <Darkener ref={this.onImageRef.bind(this)} className="meeting-booking__image-outer">
                <div className="meeting-booking__image-outer" style={{ 
                    backgroundImage: `url('${featuredImage}')`
                }}></div>
            </Darkener>

            <Layout
                onlyContent
                theme="light"
                topLeft={<Welcome breadcrumbs={[
                    {
                        name: 'Memberships',
                        link: ''
                    },
                    {
                        name: this.state.membership?.name,
                        link: ''
                    }
                ]} subtitle={this.state.membership?.name}/>}
                topRight={
                    <Row gap="20px">
                        <button className="meeting-booking__proceed meeting-booking__proceed--black" onClick={() => window.history.back()}>
                            <NavItem slug="#" text="Cancel Your Purchase" />
                        </button>
                    </Row>
                }
                topBarRef={this.onTopBarRef.bind(this)}
            >
                <MinMaxLayout
                main={
                    <div className="booking-view meeting-booking__inner">
                        <List gap="40px" className="booking-view__child">
                            <Container>
                                <Container.Header>
                                    <Container.Text color="#FF6933" fontSize="18px">Confirm Details</Container.Text>
                                </Container.Header>

                                <Container.Content> 
                                    <List gap="40px">
                                        <div className="booking-view__image" style={{ backgroundImage: `url('${this.getFeaturedImage()}')` }}></div>

                                        <LabelContainer label='Membership Plan'>
                                            { this.state.membership?.name }
                                        </LabelContainer>

                                        <LabelContainer label="Renewal">
                                            every { FormatMonths(this.state.membership?.renewal_interval_month) }
                                        </LabelContainer>

                                        <LabelContainer label='Cost'>
                                            £{ this.state.membership?.monthly_price }
                                        </LabelContainer>

                                        <LabelContainer label='Whats Included'>
                                            <ul style={{
                                                paddingLeft: '20px',
                                            }}>
                                                { this.state.membership?.content?.features?.map((feature, index) => {
                                                    return <li key={index}>{ feature ?.name }</li>
                                                }) }
                                            </ul>
                                        </LabelContainer>
                                    </List>
                                </Container.Content>
                            </Container>
                        </List>

                        <Container className="booking-view__child">
                            <Container.Header>
                                <Container.Text color="#FF6933" fontSize="18px">Summary</Container.Text>
                            </Container.Header>

                            <Container.Content>
                                <List gap="40px">
                                    <Summary
                                        membership={this.state.membership}
                                    />

                                    <div className="agree-box" style={{ padding: '0px', }}>
                                        <div className="agree-box__inner">
                                            <InputsCheckbox
                                                text="I have read and agree to the booking terms and conditions"
                                                checked={this.state.agree}
                                                onChange={(e) => this.setState({ agree: e.value })}
                                            />
                                            <div className="agree-box__content">
                                                <div className="agree-box__details">
                                                    <div className="agree-box-details__detail">
                                                        <p>Total</p>
                                                        <span>£{ this.state.membership?.monthly_price }</span>
                                                    </div>
                                                </div>

                                                <Blurred toggled={!this.state.agree}>
                                                    <button className="meeting-booking__proceed">
                                                        <NavItem slug="#" onClick={this.handleProceed.bind(this)} text="Proceed To Booking" />
                                                    </button>
                                                </Blurred>
                                            </div>
                                        </div>
                                    </div>

                                    <Container>
                                        <Container.Header>
                                            <Container.Text fontSize="18px" color="#FF6933">Description</Container.Text>
                                        </Container.Header>

                                        <Container.Content>
                                            <Container.Text fontSize="14px" color="#24191F" html={this.state.membership?.description}></Container.Text>
                                        </Container.Content>
                                    </Container>

                                    <Container>
                                        <Container.Header>
                                            <Container.Text fontSize="18px" color="#FF6933">Contact Us</Container.Text>
                                        </Container.Header>

                                        <Container.Content>
                                            <Container.Text fontSize="14px" color="#24191F">
                                                +44 (0)1226 720 700

                                                bookings@barnsleydmc.co.uk

                                                DMC
                                                County Way
                                                Barnsley
                                                S70 2JW
                                                UK
                                            </Container.Text>
                                        </Container.Content>
                                    </Container>
                                </List>
                            </Container.Content>
                        </Container>
                    </div>
                }
            />
            </Layout>
        </div>
    }
}

if (el)  {
    ReactDOM.render(<Membership id={el.getAttribute('data-id')}/>, el);
}


